import React, { FunctionComponent } from "react";

const PaperWriteIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/interface-essential/form-edition/paper-write
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-0.25 -0.25 24.5 24.5">
      <g>
        <path
          d="M13.05,19.14l-3.72.53L9.86,16l9.55-9.54a2.25,2.25,0,0,1,3.18,3.18Z"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <rect
          x="4.75"
          y="0.75"
          width="8.5"
          height="4"
          rx="0.75"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></rect>
        <path
          d="M13.25,2.75h2.5a1.5,1.5,0,0,1,1.5,1.5"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M17.25,18.75v3a1.5,1.5,0,0,1-1.5,1.5H2.25a1.5,1.5,0,0,1-1.5-1.5V4.25a1.5,1.5,0,0,1,1.5-1.5h2.5"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <line
          x1="5.25"
          y1="8.75"
          x2="12.25"
          y2="8.75"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></line>
        <line
          x1="5.25"
          y1="13.25"
          x2="7.75"
          y2="13.25"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></line>
      </g>
    </svg>
  );
};

export default PaperWriteIcon;
